if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();

      this.isThumbnails = false;
 
      // swiper container
      this.swiperContainer = this.querySelector(".swiper-container");
      this.config = this.swiperContainer?.dataset || {};

      // Check thumbnails available or not
      if (this.config.thumbs) {
        this.isThumbnails = true;
      }

      // wait for swiper slider
      this.waitForSwiper(() => {
        // If thumbnails available
        this.initSwiperWithThumbs(this.swiperContainer);
      });

      // Pause videos when the page is unloaded
      window.addEventListener('beforeunload', this.pauseAllVideos);

      // Pause videos when the component is disconnected
      this.observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            mutation.removedNodes.forEach(node => {
              if (node === this) {
                this.pauseAllVideos();
              }
            });
          }
        }
      });

      this.observer.observe(document.body, { childList: true });
    }

    // Pause all videos
    pauseAllVideos() {
      document.querySelectorAll('video').forEach(video => {
        video.pause();
      });
    }

    // Wit for swiper slider
    waitForSwiper(trigger) {
      var interval = setInterval(() => {
        if (typeof Swiper !== "undefined") {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(() => {
        clearInterval(interval);
      }, 15000);
    }

    // Thumbnail configuration
    thumbConfig(thumbConfig) {
      var config = {
        slidesPerView: 3,
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        freeMode: false,
        mousewheel: false,
        slideToClickedSlide: true,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        loop: false,
        keyboard: {
          enabled: true,
        },
        direction: "horizontal",
      };

      // Loop
      config.loop = thumbConfig.loop == "true";

      // Slide per view
      if (thumbConfig?.slidesPerView > 1) {
        config.slidesPerView = thumbConfig.slidesPerView;
      }

      // direction
      if (thumbConfig.direction) {
        config.direction = thumbConfig.direction;
      }

      // Breakpoints
      if (thumbConfig.breakpoints) {
        config.breakpoints = JSON.parse(thumbConfig.breakpoints);
      }

      // autoplay
      if (thumbConfig.autoplay == "true") {
        config.autoplay = {
          delay: thumbConfig.delay || 5000,
        };
      }

      // allowTouchMove
      config.allowTouchMove = thumbConfig.allowTouchMove == "true";

      return config;
    }

    // Gallery slider configuration
    galleryConfiguration(galleryConfig, thumbs) {
      var config = {
        slidesPerView: 1,
        spaceBetween: 12,
        centeredSlides: false,
        loop: false,
        direction: "horizontal",
        thumbs: {},
        pagination: {
          el: "",
          clickable: true,
        },
        navigation: {
          nextEl: "",
          prevEl: "",
        },
        on: {
          init: function (resp) {
            resp.el.parentElement.parentElement.classList.add('slideCount-' + resp.slides.length);
          },
          slideChange: function (e) {
            // Pause all videos
            document.querySelectorAll('.custPuraVidaVideoWrapper video').forEach(video => {
              video.pause();
            });

            // Pause the video on the previous slide and play the video on the current slide
            if (e.el.closest('.newbornNestPlayVideoSlider')) {
              document.querySelectorAll('.newbornNestPlayVideoSlider video').forEach(video => {
                video.pause();
              });
              document.querySelectorAll('.newbornNestVideoWrapper').forEach(item => {
                item.classList.remove('playing');
              });
              const currentSlide = e.el.querySelector('.swiper-slide-active .newbornNestVideoWrapper');
              if (currentSlide) {
                currentSlide.classList.add('playing');
                const currentVideo = currentSlide.querySelector('video');
                if (currentVideo) {
                  currentVideo.volume = 0.5;
                  currentVideo.play();
                }
              }
            }
          },
          slideChangeTransitionEnd: function (e) {
            // Ensure the video on the previous slide is paused after the transition ends
            document.querySelectorAll('.custPuraVidaVideoWrapper video').forEach(video => {
              if (!video.closest('.swiper-slide-active')) {
                video.pause();
              }
            });

            if (e.el.closest('.newbornNestPlayVideoSlider')) {
              document.querySelectorAll('.newbornNestPlayVideoSlider video').forEach(video => {
                if (!video.closest('.swiper-slide-active')) {
                  video.pause();
                }
              });
            }
          }
        }
      };

      // Pagination
      if (galleryConfig.dots) {
        config.pagination.el = galleryConfig.pagination;
      }

    

      // Loop
      config.loop = galleryConfig.loop == "true";
  console.log("gallyer cifug -> ", galleryConfig)
      // If prev/next element
      if (galleryConfig?.nav) {
        config.navigation.prevEl = galleryConfig.prevEl;
        config.navigation.nextEl = galleryConfig.nextEl;
      }

      // direction
      if (galleryConfig.direction) {
        config.direction = galleryConfig.direction;
      }

      // per view
      if (galleryConfig?.slidesPerView > 1) {
        config.slidesPerView = galleryConfig.slidesPerView;
      }

      // if thumbs
      if (thumbs) {
        config.thumbs.swiper = thumbs;
      }

      // autoplay
      if (galleryConfig.autoplay == "true") {
        config.autoplay = {
          delay: galleryConfig.delay || 4000,
        };
      }

      // Breakpoints
      if (galleryConfig.breakpoints) {
        config.breakpoints = JSON.parse(galleryConfig.breakpoints);
      }

      // allowTouchMove
      config.allowTouchMove = galleryConfig.allowTouchMove == "true";

      return config;
    }

    // remove duplicate slider
    removeDuplicateSlides(slides) {
      slides.forEach(slide => {
        if (slide.classList.contains("swiper-slide-duplicate")) {
          slide.remove();
        }
      });
    }

    // Initlize swiper slider with thumbs
    initSwiperWithThumbs() {
      // Thumbnails
      var sliderThumbs = document.querySelector(`${this.config["thumbsId"]}`);

      // Thumbnails initialize
      var thumbs;
      if (sliderThumbs) {
        var thumbConfig = sliderThumbs.dataset;
        thumbConfig = this.thumbConfig(thumbConfig);
        // Thumbnails
        thumbs = new Swiper(sliderThumbs, thumbConfig);
      }

      if (this.swiperContainer) {
        var galleryConfig = this.galleryConfiguration(this.config, thumbs);

        // Add click event listener to the swiper slider
        var gallerySl = new Swiper(this.swiperContainer, galleryConfig);

        // Add an event listener to the gallery swiper's 'slideChange' event
        if (thumbs) {
          thumbs.params.slideToClickedSlide = true;

          // Remove loop
          var totalSlides = 0;
          thumbs.slides.forEach(slide => {
            if (!slide.classList.contains("swiper-slide-duplicate")) {
              totalSlides++;
            }
          });

          if (totalSlides === thumbs.params.slidesPerView) {
            thumbs.params.loop = false;
            gallerySl.params.loop = false;
            this.removeDuplicateSlides(thumbs.slides);
            this.removeDuplicateSlides(gallerySl.slides);
            thumbs.update();
            gallerySl.update();
          }

          gallerySl.on("slideChange", function () {
            if (thumbs.params.slidesPerView === 1.5) {
              // Get the active slide index of the gallery swiper
              var activeSlideIndex = gallerySl.activeIndex;

              // Calculate the corresponding active thumbnail slide index
              var activeThumbnailIndex = Math.floor(activeSlideIndex * 1.5);

              if (activeThumbnailIndex - activeSlideIndex > 1) {
                activeThumbnailIndex = activeThumbnailIndex - 1;
              }

              // Slide to the active thumbnail slide to make it fully visible
              thumbs.slideTo(activeThumbnailIndex);
            }
          });
        }
      }
    }
  }
  customElements.define("swiper-slider", SwiperSlider);
} 